export function tableOfContents(sections) {
            const items = [];
            function traverse(sections) {
                sections?.forEach(section => {
                    const title = section?.clearanceMemoSection?.title;
                    const position = section?.position;
                    if (title || position) {
                        items.push({ position, title });
                    }
                    if (Array.isArray(section?.children) && section.children.length > 0) {
                        traverse(section.children);
                    }
                });
            }
            traverse(sections);
            return items;
        }